import { render, staticRenderFns } from "./OverdueTaskJobTable.vue?vue&type=template&id=4f80152d"
import script from "./OverdueTaskJobTable.vue?vue&type=script&lang=js"
export * from "./OverdueTaskJobTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports